import React from 'react';
import {useParams} from 'react-router-dom';
import FormularioSenha from './components/FormularioSenha';
export default function ResetSenha(){const {idchave}=useParams();return <FormularioSenha chave={idchave}/>;}
